import React, { useContext, useEffect, useState } from "react";

import ApplicationContext from "../../../context/ApplicationContext";
import { ISnookerProps } from "./ISnookerProps";

import "react-simple-keyboard/build/css/index.css";
import {
  defaultSnookerTable,
  ISnookerTable,
} from "../../../types/ISnookerTable";
import { getSettings, getSnookerTables } from "../../../services/Service";
import {
  Dropdown,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  Menu,
  MenuItem,
  Segment,
} from "semantic-ui-react";
import { Button } from "react-bootstrap";
import { ITableStatusProps, TableStatus } from "../TableStatus";
import {
  remainingTime,
  reminderInSeconds,
  totalDuration,
  totalSnookerTable,
} from "../../helpers/Helpers";
import { IStyleSettings } from "../../../types/IStyleSettings";
import { addSeconds } from "../../../helpers/Helper";
import { ISnookerStyleSettings } from "../../../types/ISnookerStyleSettings";

export const Snooker: React.FC<ISnookerProps> = (
  props: ISnookerProps
): JSX.Element => {
  const context = useContext(ApplicationContext);

  // const [snookerTable, setSnookerTables] = useState<ISnookerTable[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [selectedTable, setSelectedTable] = React.useState(defaultSnookerTable);

  const [dateTime, setDateTime] = React.useState(new Date());
  const [refreshDateTime, setRefreshDateTime] = React.useState(new Date());

  const [showTables, setShowTabes] = React.useState(true);
  const [showSingleTable, setShowSingleTable] = React.useState(false);

  const [alarm, setAlarm] = React.useState(false);

  let snookerTable: ISnookerTable[] = [];

  const synTables = context.Snooker.getData();

  if (synTables !== undefined) {
    snookerTable = synTables;
  }

  async function settings() {
    setLoading(true);

    const response = await getSettings(context.AuthenticatedUser.getToken());

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    context.BranchMenu.setMenu(response.menu);
    context.Configuration.setSettings(response.branchSettings);

    setLoading(false);
  }

  async function snookerTables() {
    setLoading(true);

    const response = await getSnookerTables(
      context.AuthenticatedUser.getToken()
    );

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    context.Snooker.setData(response);

    setLoading(false);
  }

  function updateTables() {
    if (refreshDateTime < dateTime) {
      snookerTables();
      const dt = new Date();
      setRefreshDateTime(addSeconds(dt, 60));
    }
  }

  useEffect(() => {
    settings();
  }, []);

  function updateAlarm() {
    setAlarm(!alarm);
  }

  useEffect(() => {
    setDateTime(props.dateTime);
    updateTables();

    updateAlarm();
  }, [props.dateTime]);

  async function OrganisationSettings() {
    setLoading(true);

    const response = await getSettings(context.AuthenticatedUser.getToken());

    if (!response) {
      context.ApplicationError.setHasError(true);
      return;
    }

    context.BranchMenu.setMenu(response.menu);
    context.Configuration.setSettings(response.branchSettings);

    setLoading(false);
  }

  useEffect(() => {
    OrganisationSettings();
  }, []);

  function clearViews() {
    setShowTabes(false);
    setShowSingleTable(false);
  }

  function onTableClick(st: ISnookerTable) {
    clearViews();
    setSelectedTable(st);
    setShowSingleTable(true);
    context.Snooker.setSelected(st);
  }

  function tableColor(st: ISnookerTable) {
    let btnStyle: ISnookerStyleSettings = JSON.parse(st.style);

    if (st.hasStarted === false) {
      return btnStyle.StoppedColour;
    }

    if (st.hasStarted && st.reminderInMinutes === -1) {
      return btnStyle.RunningColour;
    }

    const reminder = reminderInSeconds(st);

    if (st.hasStarted && st.advancePayment > 0 && reminder > 0) {
      return btnStyle.AdvancePayColour;
    }

    if (reminder > -30 && reminder < 0) {
      if (alarm) {
        return btnStyle.AlarmColour;
      } else {
        return btnStyle.RunningColour;
      }
    }

    if (st.hasStarted && reminder > 0) {
      return btnStyle.AdvancePayColour;
    }

    return btnStyle.AlarmColour;
  }

  function textColor(st: ISnookerTable) {
    let btnStyle: ISnookerStyleSettings = JSON.parse(st.style);

    if (st.hasStarted === false) {
      return btnStyle.TextColourStopped;
    }

    if (st.hasStarted && st.reminderInMinutes === -1) {
      return btnStyle.TextColourRunning;
    }

    const reminder = reminderInSeconds(st);

    if (st.hasStarted && st.advancePayment > 0 && reminder > 0) {
      return btnStyle.TextColourAdvancePay;
    }

    if (reminder > -30 && reminder < 0) {
      if (alarm) {
        return btnStyle.TextColourAlarm;
      } else {
        return btnStyle.TextColourAlarm;
      }
    }

    if (st.hasStarted && reminder > 0) {
      return btnStyle.TextColourAdvancePay;
    }

    return btnStyle.TextColourAlarm;
  }

  function buttonHeight(st: ISnookerTable) {
    let btnStyle: ISnookerStyleSettings = JSON.parse(st.style);
    return btnStyle.ButtonHeight + "px";
  }

  function buttonWidth(st: ISnookerTable) {
    let btnStyle: ISnookerStyleSettings = JSON.parse(st.style);
    return btnStyle.ButtonWidth + "px";
  }

  function fontSize(st: ISnookerTable) {
    let btnStyle: ISnookerStyleSettings = JSON.parse(st.style);
    return btnStyle.FontSize + "px";
  }

  function advancePayment(table: ISnookerTable) {
    if (table.hasStarted && table.advancePayment > 0) {
      return "Adv Pay: £" + table.advancePayment.toFixed(2);
    }
    return <></>;
  }

  const tablesView = (): JSX.Element => {
    return (
      <>
        {/* <Container> */}
        <Segment inverted>
          <Menu inverted secondary>
            <MenuItem
              name="All Tables"
              active={true}
              // onClick={this.handleItemClick}
            />
            <MenuItem
              name="Booking"
              // active={activeItem === "messages"}
              // onClick={this.handleItemClick}
            />
            <MenuItem
              name="Queue"
              // active={activeItem === "messages"}
              // onClick={this.handleItemClick}
            />

            <Dropdown item text="Settings">
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    // @ts-ignore */
                    window.location.reload(true);
                  }}
                >
                  Update
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Menu>
        </Segment>
        {/* </Container> */}

        <div style={{ padding: 5 }}>
          {snookerTable
            .sort((a, b) => (a.position > b.position ? 1 : -1))
            .map((t) => (
              <>
                {t.description !== "123456789" ? (
                  <Button
                    className="mr-1"
                    variant="outline-primary bt-lg"
                    style={{
                      width: buttonWidth(t),
                      height: buttonHeight(t),
                      fontWeight: "bolder",
                      backgroundColor: tableColor(t),
                      borderRadius: "10px",
                      color: textColor(t),
                      fontSize: fontSize(t),
                    }}
                    onClick={() => onTableClick(t)}
                    key={t.id}
                  >
                    <div>{t.description}</div>
                    {t.hasStarted ? <div>{totalDuration(t)} </div> : <></>}
                    <div>
                      {t.hasStarted ? (
                        <>
                          £{totalSnookerTable(t)} | £{t.peekPrice}
                        </>
                      ) : (
                        <>£{t.peekPrice}</>
                      )}
                    </div>
                    <div>{remainingTime(t)}</div>
                    <div>{advancePayment(t)}</div>
                  </Button>
                ) : (
                  <div>
                    <br />
                    <hr />
                  </div>
                )}
              </>
            ))}
        </div>
      </>
    );
  };

  function closeTableProps() {
    clearViews();
    setShowTabes(true);
    snookerTables();
  }

  const snookerTableProps: ITableStatusProps = {
    close: () => closeTableProps(),
    updateTables: () => snookerTables(),
    table: selectedTable,
    dateTime: props.dateTime,
  };

  return (
    <>
      <>{showTables ? tablesView() : <></>}</>
      <>{showSingleTable ? <TableStatus {...snookerTableProps} /> : <></>}</>
    </>
  );
};
